module.exports = __webpack_public_path__ + "static/media/triangle-dots-top.db3a6ede.png";